import { persistUTMQueryParamsToString } from "@common/utils/router";
import {
  Anchor,
  Box,
  Flex,
  Text,
  Tooltip,
  useMantineTheme,
} from "@mantine/core";
import Link from "next/link";
import { useRouter } from "next/router";
import { ReactElement } from "react";
import { INewInstanceDropdownLinkProps } from "./types";
import IconGem from "@common/components/icons/IconGem";
import { useStyles } from "./NewInstanceDropdownLink.styled";

export function NewInstanceDropdownLink({
  "data-testid": dataTestid,
  href,
  copy,
  icon,
  disabled,
  disabledCopy,
  highlight,
}: INewInstanceDropdownLinkProps): ReactElement {
  const theme = useMantineTheme();
  const { classes } = useStyles({ disabled });

  const router = useRouter();

  return (
    <Tooltip
      data-testid={`${dataTestid}-tooltip`}
      arrowSize={theme.spacing.xs}
      closeDelay={300}
      color="dark"
      disabled={!disabled}
      label={disabledCopy}
      multiline
      opened={disabled && disabledCopy ? undefined : false}
      position="left"
      withArrow
      withinPortal
      fz="xs"
      px={theme.spacing.md}
      py={theme.spacing.xs}
    >
      <Box>
        <Anchor
          data-testid={dataTestid}
          component={Link}
          className={classes.dropdownLink}
          display="block"
          fz="sm"
          href={persistUTMQueryParamsToString(router, href)}
        >
          <Flex
            align="center"
            direction="row"
            gap="xs"
            justify="space-between"
            wrap="nowrap"
            p="xs"
          >
            <Flex
              align="center"
              direction="row"
              gap="xs"
              justify="flex-start"
              wrap="nowrap"
            >
              <Flex className="icon" miw={16} mt={1} w={16}>
                {icon}
              </Flex>

              <Text span>{copy}</Text>
            </Flex>

            {highlight && (
              <Box miw={16} mt={(-theme.spacing.xs * 2) / 3} w={16}>
                <IconGem color={theme.colors.blue[2]} />
              </Box>
            )}
          </Flex>
        </Anchor>
      </Box>
    </Tooltip>
  );
}
